const BASE_PATH = '/src/assets/images';

// Icons
import ico_download from '../assets/images/ico_download.png';

// Logos
import logoImage from '../assets/images/logo.png';

// Backgrounds
import bg1_1 from '../assets/images/bg1_1.jpg';
import bg1_1_m from '../assets/images/bg1_1_m.jpg';
import bg1_2 from '../assets/images/bg1_2.jpg';
import bg1_2_m from '../assets/images/bg1_2_m.jpg';
import bg2 from '../assets/images/bg2.jpg';
import bg2_m from '../assets/images/bg2_m.jpg';
import bg3 from '../assets/images/bg3.jpg';
import bg3_m from '../assets/images/bg3_m.jpg';
import bg4 from '../assets/images/bg4.jpg';
import bg4_m from '../assets/images/bg4_m.jpg';
// import bg5 from '../assets/images/bg5.jpg';
// import bg5_m from '../assets/images/bg5_m.jpg';
// import bg6 from '../assets/images/bg6.jpg';
// import bg6_m from '../assets/images/bg6_m.jpg';
// import bg_main from '../assets/images/bg_main_banner.jpg';
// import bg_main_m from '../assets/images/bg_main_banner_m.jpg';
import bg_main from '../assets/images/bg_main_top_banner.jpg';
import bg_main_m from '../assets/images/bg_main_top_banner_m.jpg';
import bg_contact from '../assets/images/contact_bg.jpg';
import bg_contact_m from '../assets/images/contact_bg_m.jpg';

// Content Images
import title_main_banner from '../assets/images/title_main_banner.png';
import title_main_banner_m from '../assets/images/title_main_banner_m.png';
import title_main_banner_btn from '../assets/images/title_main_banner_btn.png';
import title_main_banner_btn_m from '../assets/images/title_main_banner_btn_m.png';

import title_main_banner_1 from '../assets/images/title_main_banner_1.png';
import title_main_banner_1_m from '../assets/images/title_main_banner_1_m.png';
import title_main_banner_2 from '../assets/images/title_main_banner_2.png';
import title_main_banner_2_m from '../assets/images/title_main_banner_2_m.png';
import title_main_banner_3 from '../assets/images/title_main_banner_3.png';
import title_main_banner_3_m from '../assets/images/title_main_banner_3_m.png';
  // import img1 from '../assets/images/img1.png';
// import img1_m from '../assets/images/img1_m.png';
import img1_1 from '../assets/images/img1_1.png';
import img1_1_m from '../assets/images/img1_1_m.png';
import img1_1_2 from '../assets/images/img1_1_2.png';
import img1_1_2_m from '../assets/images/img1_1_2_m.png';
import img1_2 from '../assets/images/img1_2.png';
import img1_2_m from '../assets/images/img1_2_m.png';
import img1_3 from '../assets/images/img1_3.png';
import img1_3_m from '../assets/images/img1_3_m.png';
import img1_4 from '../assets/images/img1_4.png';
import img1_4_m from '../assets/images/img1_4_m.png';
import img1_5 from '../assets/images/img1_5.png';
import img1_5_m from '../assets/images/img1_5_m.png';
import img1_8 from '../assets/images/img1_8.png';
// import img2_title from '../assets/images/img2_titlKtle_m.png';
import img2_1 from '../assets/images/img2_1.png';
import img2_1_m from '../assets/images/img2_1_m.png';
import img2_1_title from '../assets/images/img2_1_title.png';
import img2_1_m_title from '../assets/images/img2_1_m_title.png';
import img3 from '../assets/images/img3.png';
import img3_m from '../assets/images/img3_m.png';
import img4 from '../assets/images/img4.png';
import img4_m from '../assets/images/img4_m.png';
import img4_title from '../assets/images/img4_title.png';
import img4_m_title from '../assets/images/img4_m_title.png';
// import img6 from '../assets/images/img6.png';
// import img6_m from '../assets/images/img6_m.png';
import contact from '../assets/images/contact.png';
import contact_m from '../assets/images/contact_m.png';

// Contact Images
import contact_1 from '../assets/images/contact_1.png';
import contact_1_m from '../assets/images/contact_1_m.png';
import contact_2 from '../assets/images/contact_2.png';
import contact_2_m from '../assets/images/contact_2_m.png';
import contact_3 from '../assets/images/contact_3.png';
import contact_3_m from '../assets/images/contact_3_m.png';
import contact_4 from '../assets/images/contact_4.png';
import contact_4_m from '../assets/images/contact_4_m.png';

// Apply Section Images
import img6_1 from '../assets/images/img6_1.png';
import img6_1_m from '../assets/images/img6_1_m.png';
import img6_btn from '../assets/images/img6_btn.png';
import img6_btn_m from '../assets/images/img6_btn_m.png';
import img6_2 from '../assets/images/img6_2.png';
import img6_2_m from '../assets/images/img6_2_m.png';
import bg6 from '../assets/images/bg6.jpg';
import bg6_m from '../assets/images/bg6_m.jpg';

// Application
import bg_apply from '../assets/images/bg_apply.jpg';

export const sectorImages = {
  icons: {
    download: ico_download
  },
  logos: {
    main: logoImage
  },
  main: { // Main
    // title: {
    //   pc: title_main_banner,
    //   mobile: title_main_banner_m
    // },
    title1: {
      pc: title_main_banner_1,
      mobile: title_main_banner_1_m
    },
    title2: {
      pc: title_main_banner_2,
      mobile: title_main_banner_2_m
    },
    title3: {
      pc: title_main_banner_3,
      mobile: title_main_banner_3_m
    },
    button: {
      pc: title_main_banner_btn,
      mobile: title_main_banner_btn_m
    },
    bg: {
      pc: bg_main,
      mobile: bg_main_m
    }
  },
  sector01: { // Overview-1
    content: {
      pc: img1_1,
      mobile: img1_1_m
    },
    bg: {
      pc: bg1_1,
      mobile: bg1_1_m
    },
    logosThree: img1_8,
  },
  sector02: { // Overview-2
    content: {
      pc: img1_1, // Origin : img1_2
      mobile: img1_1_m // Origin : img1_2_m
    },
    desc: {
      pc: img1_1_2, // Origin : img1_2
      mobile: img1_1_2_m // Origin : img1_2_m
    },
    stats: {
      video: img1_2,
      title1: {
        pc: img1_3,
        mobile: img1_3_m
      },
      title2: {
        pc: img1_4,
        mobile: img1_4_m
      },
      title3: {
        pc: img1_5,
        mobile: img1_5_m
      },
      logosThree: img1_8
    },
    bg: {
      pc: bg1_2,
      mobile: bg1_2_m
    }
  },
  sector03: { // Benefits
    title: {
      pc: img2_1_title,
      mobile: img2_1_m_title
    },
    content1: {
      pc: img2_1,
      mobile: img2_1_m
    },
    bg: {
      pc: bg2,
      mobile: bg2_m
    }
  },
  sector04: { // Requirements
    content: {
      pc: img3,
      mobile: img3_m
    },
    bg: {
      pc: bg3,
      mobile: bg3_m
    }
  },
  sector05: { // Itinerary
    title: {
      pc: img4_title,
      mobile: img4_m_title
    },
    content: {
      pc: img4,
      mobile: img4_m
    },
    bg: {
      pc: bg4,
      mobile: bg4_m
    }
  },
  // sector05: { // Not Used
  //   content: {
  //     pc: img5,
  //     mobile: img5_m
  //   },
  //   bg: {
  //     pc: bg5,
  //     mobile: bg5_m
  //   }
  // },
  // sector06: { // Contact
  //   content: {
  //     pc: img6,
  //     mobile: img6_m
  //   },
  //   bg: {
  //     pc: bg6,
  //     mobile: bg6_m
  //   }
  // },
  sectorContact: { // Contact
    content: {
      pc: contact,
      mobile: contact_m
    },
    contactImages: {
      contact1: {
        pc: contact_1,
        mobile: contact_1_m
      },
      contact2: {
        pc: contact_2,
        mobile: contact_2_m
      },
      contact3: {
        pc: contact_3,
        mobile: contact_3_m
      },
      contact4: {
        pc: contact_4,
        mobile: contact_4_m
      }
    },
    bg: {
      pc: bg_contact,
      mobile: bg_contact_m
    }
  },
  sectorApply: { // sectorApply
    title: {
      pc: img6_1,
      mobile: img6_1_m
    },
    button: {
      pc: img6_btn,
      mobile: img6_btn_m
    },
    content: {
      pc: img6_2,
      mobile: img6_2_m
    },
    bg: {
      pc: bg6,
      mobile: bg6_m
    }
  },
  bg_apply,
};

export default sectorImages; 